import React, { FC, useContext, useMemo } from "react";
import DruidWebchatContext, { DruidWebchatContextType } from "../WebChatContext";
import useStyleToEmotionObject from 'botframework-webchat-component/lib/hooks/internal/useStyleToEmotionObject';
import classNames from "classnames";
import { useMergedOptions } from '../selectors/useMergedOptions';

import ScreenReaderText from 'botframework-webchat-component/lib/ScreenReaderText';
import useLocalizedGlobalize from 'botframework-webchat-api/lib/hooks/internal/useLocalizedGlobalize';
import useWebChatAPIContext from 'botframework-webchat-api/lib/hooks/internal/useWebChatAPIContext';

import { hooks } from 'botframework-webchat-api';
import { hooks as compHooks } from 'botframework-webchat-component';
import moment from "moment";

const {  useStyleOptions, useDateFormatter, useLocalizer } = hooks;
const { useStyleSet } = compHooks;

const DruidActivityCustomTimestamp = ({ activity: { timestamp } }) => {
    // const { localizedGlobalizeState }  = useWebChatAPIContext();
    // const [globalize] = localizedGlobalizeState  ; 
    const [{ timestampFormat }] = useStyleOptions();
    const [{ timestamp: timestampStyleSet, sendStatus: sendStatusStyleSet }] = useStyleSet();
    const { UI: {  customTimestampFormat } = {} } = useMergedOptions();

    const localize = useLocalizer();

    const druidFormatDate = useMemo(() => date => moment(new Date(date)).format(customTimestampFormat) , [
       customTimestampFormat
    ]);

    // const druidFormatDate = useMemo(() => {
    //     var globalizeFormatter = globalize.dateFormatter.bind(globalize);
    //     return (date) => 
    // }, [globalize, customTimestampFormat]);
    
    // const globalizeFormatter = globalize.dateFormatter.bind(globalize)
    const absoluteTime = druidFormatDate(timestamp) ;

    return (
        !!timestamp ? (
            <span
                className={classNames((timestampStyleSet || '') + '', (sendStatusStyleSet || '') + '')}
            >
                {<>
                    <ScreenReaderText text={localize('ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT', absoluteTime)} />
                    {<span aria-hidden={true}>{absoluteTime}</span>}
                </>}
            </span>
        ) : null
    );
};


export default DruidActivityCustomTimestamp;